import React from 'react'
import BaseIcon from 'react-icon-base'

const Cross = ({ pathProps, ...props }) => (
  <BaseIcon width="10" height="10" viewBox="0 0 10 10" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M-1113-103H327v984h-1440z" />
      <path
        fill="#FFF"
        d="M6.414 5l3.122 3.121L8.12 9.536 5 6.414 1.879 9.536.464 8.12 3.586 5 .464 1.879 1.88.464 5 3.586 8.121.464 9.536 1.88 6.414 5z"
        {...pathProps}
      />
    </g>
  </BaseIcon>
)

export default Cross
